import React from 'react'

function ContactItem({icon, text1, text2, title, link}) {
    const isExternal = link && !link.startsWith('mailto:');
    const content = (
        <div className="contact">
            <img src={icon} alt=""/>
            <div className="right-items">
                <h6>{title}</h6>
                <p>{text1}</p>
                <p>{text2}</p>
            </div>
        </div>
    );

    if (link && isExternal) {
        return (
            <div className="ContactItem">
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {content}
                </a>
            </div>
        )
    }

    if (link) {
        return (
            <div className="ContactItem">
                <a href={link}>
                    {content}
                </a>
            </div>
        )
    }

    return (
        <div className="ContactItem">
            {content}
        </div>
    )
}

export default ContactItem;
